import { useEffect } from 'react';

// Fades in every [data-reveal] element under rootRef the first time it scrolls into view.
const useRevealOnScroll = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const elements = root.querySelectorAll('[data-reveal]');
    const show = (el) => el.setAttribute('data-reveal', 'in');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(show);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [rootRef]);
};

export default useRevealOnScroll;
